<template>
  <div>
    <c-tab
      :dense="true"
      type="pagetop"
      align="left"
      :inlineLabel="true"
      :tabItems="tabItems"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :count="count"
        />
      </template>
    </c-tab>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'work-measurement-result',
  data() {
    return {
      tab: 'factorResult',
      tabItems: [
        // { name: 'result', icon: 'groups', label: '작업환경측정결과', component: () => import(`${'./workMeasureResult.vue'}`) },
        { name: 'factorResult', icon: 'perm_media', label: '유해인자별 결과조회', component: () => import(`${'./workMeasureResultFactor.vue'}`) },
        { name: 'graph', icon: 'trending_up', label: '측정치 그래프', component: () => import(`${'./workMeasureResultGraph.vue'}`) },
      ],
      period: [ '', ''],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      completeFlagItems: [
        { code: null, codeName: '전체' },
        { code: 'N', codeName: '작성중' },
        { code: 'Y', codeName: '완료' },
      ],
      count: 0,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
    },
    tabClick() {
      this.count++;
    }
  }
};
</script>
